export const capitalize = (string?: string) => {
  if (!string) return ''
  
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const normalize = (string?: string) => {
  if (!string) return ''

  return string.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const nl2br = (string?: string) => {
  if (!string) return ''

  return string.replace(/(?:\r\n|\r|\n)/g, '<br>')
}

export const nl2a = (string?: string, separator = ' ') => {
  if (!string) return ''

  return string.replace(/(?:\r\n|\r|\n)/g, separator)
}

export const plural = (length = 0) => {
  return length > 1 ? 's' : ''
}

export const stripTags = (string?: string) => {
  return (string ?? '').replace(/<br>/g, ' ').replace(/<\/p><p>/g, ' ').replace(/  /g, ' ').replace(/<[^>]*>?/gm, '').replace(/&amp;/g, '&').replace(/&nbsp;/g, ' ')
}

export const getNameList = (names: string[], options?: {
  max?: number
  and?: string
  others?: string
  total?: number
}) => {
  const max = options?.max ?? 2

  if (names.length <= 0) return ''
  if (names.length == 1) return `${names[0]}`
  if (names.length == 2) return `${names[0]} ${options?.and ?? 'et'} ${names[1]}`

  if (names.length >= max + 2) {
    const count = (options?.total ?? names.length) - max
    return `${names.slice(0, max).join(', ')} ${options?.and ?? 'et'} ${count} ${options?.others ?? 'autres'}`
  }

  if (names.length >= 3 && names.length <= 4) {
    const last = names[names.length - 1]
    return `${names.slice(0, names.length - 1).join(', ')} ${options?.and ?? 'et'} ${last}`
  }
  
  return names.join(', ')
}

export const isLineClamped = ($content: Ref<HTMLDivElement>) => {
  const isClamped = ref(false)

  watch($content, () => {
    if ($content.value) isClamped.value = $content.value.scrollHeight > $content.value.clientHeight
  }, { immediate: true })

  return {
    isClamped
  }
}

export const truncate = (string: string, words = 10) => {
  const array = string.split(' ')
  
  return array.slice(0, words).join(' ') + (array.length > words ? '...' : '')
}

export const truncateCharacters = (str: string, maxLength = 100) => {
  if (str.length <= maxLength) return str;

  const words = str.split(' ');
  let result = '';
  
  for (let word of words) {
    if ((result + word).length + 3 > maxLength) {
      // If word is too long to fit, break and cut it directly
      if (result === '') {
        return word.slice(0, maxLength - 3) + '...';
      }
      break;
    }
    result += (result ? ' ' : '') + word;
  }

  return result + '...';
}

export const beautifyLink = (url: string, options?: {
  path?: boolean
}) => {
  try {
    const urlObj = new URL(url)
    const path = urlObj.pathname.endsWith('/') ? urlObj.pathname.slice(0, -1) : urlObj.pathname

    return urlObj.hostname.replace('www.', '') + (options?.path && path.length > 0 ? path : '')
  } catch (e) {
    return url;
  }
}

export const textRandom = (length = 20) => {
  const chars = 'abcdefghijklmnopqrstuvwxyz'
  let text = ''

  while (text.length < length) {
    const wordLength = Math.floor(Math.random() * 5) + 2
    let word = ''
    for (let i = 0; i < wordLength; i++) {
      word += chars[Math.floor(Math.random() * chars.length)]
    }
    text += word + ' '
  }

  return text.trim().slice(0, length)
}